"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBUG_getCompileCache = exports.clearCompileCache = exports.compile = void 0;
var SYMBOL_END = typeof Symbol !== 'undefined'
    ? Symbol.for('a18n-compiled')
    : '__$a18n-compiled';
var cache = {};
var loadTemplate = function (parts) {
    var o = cache;
    for (var i = 0; i < parts.length && o; i++) {
        o = o[parts[i]];
    }
    return o && o[SYMBOL_END];
};
var saveTemplate = function (path, template) {
    var o = cache;
    for (var i = 0; i < path.length && o; i++) {
        o = o[path[i]] || (o[path[i]] = {});
    }
    o[SYMBOL_END] = template;
    return template;
};
var doCompile = function (parts, resource) {
    var partCount = parts.length;
    var keyTemplate = parts
        .map(function (part, i) {
        return i === partCount - 1
            ? part
            : part + "%" + (partCount === 2 ? 's' : i + 1);
    })
        .join('');
    var valueTemplate = resource[keyTemplate];
    var templateString = typeof valueTemplate === 'string' ? valueTemplate : keyTemplate;
    return templateString.split(/(%s|%\d)/g).map(function (item) {
        var _a;
        var pos = (_a = /^%(s|\d)$/g.exec(item)) === null || _a === void 0 ? void 0 : _a[1];
        if (pos) {
            return pos === 's' ? 1 : Number(pos);
        }
        else {
            return item;
        }
    });
};
/**
 * preprocess dynamic text into template, making future translation faster
 * (~10x than previous parse/interpolate approach)
 *
 * @example
 * key-value pair: { 'x%1y%2z%3w': 'aa%3bb%1cc' }
 * will generate a compiled template: ["aa", 3, "bb", 1, "cc"]
 * and be cached under path [x,y,z,w,SYMBOL_END]
 */
var compile = function (parts, resource) {
    return loadTemplate(parts) || saveTemplate(parts, doCompile(parts, resource));
};
exports.compile = compile;
var clearCompileCache = function () {
    cache = {};
};
exports.clearCompileCache = clearCompileCache;
var DEBUG_getCompileCache = function () {
    return cache;
};
exports.DEBUG_getCompileCache = DEBUG_getCompileCache;
